<template>
  <v-row>
    <v-col class="mx-auto my-auto">
      <v-card
        class="mx-auto"
        max-width="344"
        flat
      >
        <v-card-text>
          <div>Applause</div>
          <p class="display-1 text--primary">
            Applause Applause
          </p>
          <p>Greetings</p>
          <div class="text--primary">
            to all the remote Audience.
          </div>
          <div>
          Welcome to Applause. The app to give digital Applause together and also remotely.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            color="teal accent-4"
          >
            Learn More
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  // @ is an alias to /src
  export default {
    name: 'Applause',

    components: {
    },

    data: () => ({
    }),

    methods: {
    },

    created() {
    },

    mounted() {
    },
  }
</script>

<style scoped>

</style>